/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 666TdydnqTmUJpihDvjWrt
// Component: M0Hes2jXBIMM

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";
import ScrollContainer from "react-indiana-drag-scroll";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { getCookie } from "cookies-next";
import { useUserInfoStore } from "@/modules/login/store/userInfo";
import Card from "../../Card"; // plasmic-import: KIALDnHqraz9/component
import Paziresh24Button from "../../Paziresh24Button"; // plasmic-import: YOhw5fIQJQgB/component
import Paziresh24Modal from "../../Paziresh24Modal"; // plasmic-import: ZGdhyEBPJSmH/component
import { ApiRequest } from "@/common/fragment/components/api-request"; // plasmic-import: RECriOK0iPSM/codeComponent
import { KhedmatActivation } from "@/modules/hamdast/components/khedmatActivation";
import { Fetcher } from "@plasmicapp/react-web/lib/data-sources";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 666TdydnqTmUJpihDvjWrt/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 666TdydnqTmUJpihDvjWrt/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHamdastKhedmatWidget.module.css"; // plasmic-import: M0Hes2jXBIMM/css

import ChevronRightIcon from "../paziresh_24_design_system/icons/PlasmicIcon__ChevronRight"; // plasmic-import: 0359howWu0cr/icon
import ChevronLeftIcon from "../paziresh_24_design_system/icons/PlasmicIcon__ChevronLeft"; // plasmic-import: jS0YlkKPLO7U/icon
import Icon2Icon from "../paziresh_24_design_system/icons/PlasmicIcon__Icon2"; // plasmic-import: rwy2JSXIoIh2/icon

createPlasmicElementProxy;

export type PlasmicHamdastKhedmatWidget__VariantMembers = {};
export type PlasmicHamdastKhedmatWidget__VariantsArgs = {};
type VariantPropType = keyof PlasmicHamdastKhedmatWidget__VariantsArgs;
export const PlasmicHamdastKhedmatWidget__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHamdastKhedmatWidget__ArgsType = {
  profileData?: any;
  widgetData?: any;
  isInactiveView?: boolean;
};
type ArgPropType = keyof PlasmicHamdastKhedmatWidget__ArgsType;
export const PlasmicHamdastKhedmatWidget__ArgProps = new Array<ArgPropType>(
  "profileData",
  "widgetData",
  "isInactiveView"
);

export type PlasmicHamdastKhedmatWidget__OverridesType = {
  root?: Flex__<"div">;
  card?: Flex__<typeof Card>;
  paziresh24Button?: Flex__<typeof Paziresh24Button>;
  modal?: Flex__<typeof Paziresh24Modal>;
  apiRequest?: Flex__<typeof ApiRequest>;
};

export interface DefaultHamdastKhedmatWidgetProps {
  profileData?: any;
  widgetData?: any;
  isInactiveView?: boolean;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHamdastKhedmatWidget__RenderFunc(props: {
  variants: PlasmicHamdastKhedmatWidget__VariantsArgs;
  args: PlasmicHamdastKhedmatWidget__ArgsType;
  overrides: PlasmicHamdastKhedmatWidget__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "modal.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          hasVariant(globalVariants, "screen", "mobileOnly") ? false : false
      },
      {
        path: "apiRequest.data",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "apiRequest"
      },
      {
        path: "apiRequest.error",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "apiRequest"
      },
      {
        path: "apiRequest.loading",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "apiRequest"
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $globalActions = useGlobalActions?.();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  const isMobile = hasVariant(globalVariants, "screen", "mobileOnly");
  const ScrollContainerComponent = isMobile ? "div" : ScrollContainer;
  const hasScrolledRef = React.useRef(false);
  const [consultationModalOpen, setConsultationModalOpen] = React.useState(false);
  const [selectedConsultationItem, setSelectedConsultationItem] = React.useState<any>(null);

  const currentUserInfo = useUserInfoStore(state => state.info);
  const isOwnDoctor = Boolean(
    (currentUserInfo?.id && $props.profileData?.user_id && String(currentUserInfo.id) === String($props.profileData.user_id)) ||
    ($ctx.auth?.info?.id && $props.profileData?.user_id && String($ctx.auth.info.id) === String($props.profileData.user_id))
  );

  const handleActivationClick = async () => {
    if (typeof window !== "undefined") {
      window.open("https://www.paziresh24.com/_/khedmat/launcher/?direct=true", "_blank", "noopener,noreferrer");
    }
    try {
      await $globalActions["Fragment.apiRequest"]?.apply(null, [
        "POST",
        "https://apigw.paziresh24.com/v1/hamdast/widget-data/khedmat/log-webhook",
        undefined,
        {
          event_group: "khedmat_click_activation",
          doctor_user_id: $props.profileData?.user_id,
          doctor_slug: $props.profileData?.seo?.slug,
          user_id: $ctx.auth?.info?.id || currentUserInfo?.id,
          terminal_id: getCookie("terminal_id")
        }
      ]);
    } catch (e) {
      console.error("Failed to log activation click:", e);
    }
  };

  const isInactive = Boolean(
    $props.isInactiveView ||
    ($state.apiRequest.data?.length > 0 &&
      ($state.apiRequest.data?.[0]?.plus === false || $state.apiRequest.data?.[0]?.plus === "false"))
  );

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_666TdydnqTmUJpihDvjWrt",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {(() => {
        try {
          return (
            $state.apiRequest.data?.length > 0 &&
            $state.apiRequest.data?.[0]?.plus == true &&
            !isInactive
          );
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return true;
          }
          throw e;
        }
      })() ? (
        <ScrollContainerComponent
          className={classNames("all", sty.freeBox__q8Pqw, isMobile ? "no-scroll" : "")}
          {...(!isMobile && { hideScrollbars: false })}
          onScroll={async () => {
            if (hasScrolledRef.current) return;
            hasScrolledRef.current = true;
            try {
              await $globalActions["Fragment.apiRequest"]?.apply(null, [
                "POST",
                "https://apigw.paziresh24.com/v1/hamdast/widget-data/khedmat/log-webhook",
                undefined,
                {
                  event_group: "khedmat_scroll",
                  doctor_user_id: $props.profileData?.user_id,
                  doctor_slug: $props.profileData?.seo?.slug,
                  user_id: $ctx.auth?.info?.id,
                  terminal_id: getCookie("terminal_id")
                }
              ]);
            } catch (e) {
              console.error("Failed to log khedmat_scroll event:", e);
            }
          }}
        >
          {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
            (() => {
              try {
                return $state.apiRequest.data;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()
          ).map((__plasmic_item_0, __plasmic_idx_0) => {
            const currentItem = __plasmic_item_0;
            const currentIndex = __plasmic_idx_0;
            const isFreeConsultation = currentItem.consultation === true || currentItem.consultation === "true" || currentItem.consultalion === true || currentItem.consultalion === "true";
            return (
              <Card
                data-plasmic-name={"card"}
                data-plasmic-override={overrides.card}
                attributes={currentItem.attributes}
                className={classNames("__wab_instance", sty.card)}
                buttonText={isFreeConsultation ? "\u062f\u0631\u06cc\u0627\u0641\u062a \u0645\u0634\u0627\u0648\u0631\u0647 \u0631\u0627\u06cc\u06af\u0627\u0646 \u0627\u0632 \u062f\u06a9\u062a\u0631" : undefined}
                imageLink={(() => {
                  try {
                    return currentItem.image_link;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
                key={currentIndex}
                onClick={async () => {
                  if (isFreeConsultation) {
                    try {
                      await $globalActions["Fragment.apiRequest"]?.apply(null, [
                        "POST",
                        "https://apigw.paziresh24.com/v1/hamdast/widget-data/khedmat/log-webhook",
                        undefined,
                        {
                          event_group: "khedmat_click_consultation",
                          doctor_user_id: $props.profileData.user_id,
                          doctor_slug: $props.profileData.seo.slug,
                          user_id: $ctx.auth?.info?.id,
                          service: currentItem.service,
                          sevice: currentItem.service,
                          id: currentItem.id,
                          terminal_id: getCookie("terminal_id")
                        }
                      ]);
                    } catch (e) {
                      console.error("Failed to log consultation click:", e);
                    }
                    setSelectedConsultationItem(currentItem);
                    setConsultationModalOpen(true);
                    return;
                  }
                  const $steps = {};

                  $steps["goToPage"] = true
                    ? (() => {
                        const actionArgs = {
                          destination: (() => {
                            try {
                              return `https://www.paziresh24.com/booking/${$props.profileData.seo.slug}/?centerId=${$props.widgetData?.center_id}`;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return "";
                              }
                              throw e;
                            }
                          })()
                        };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            __nextRouter?.push(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToPage"] != null &&
                    typeof $steps["goToPage"] === "object" &&
                    typeof $steps["goToPage"].then === "function"
                  ) {
                    $steps["goToPage"] = await $steps["goToPage"];
                  }

                  $steps["invokeGlobalAction"] = true
                    ? (() => {
                        const actionArgs = {
                          args: [
                            "POST",
                            "https://apigw.paziresh24.com/v1/hamdast/widget-data/khedmat/log-webhook",
                            undefined,
                            {
                              event_group: "khedmat_click_card",
                              doctor_user_id: $props.profileData.user_id,
                              doctor_slug: $props.profileData.seo.slug,
                              user_id: $ctx.auth?.info?.id,
                              sevice: currentItem.service,
                              id: currentItem.id,
                              terminal_id: getCookie("terminal_id")
                            }
                          ]
                        };
                        return $globalActions["Fragment.apiRequest"]?.apply(
                          null,
                          [...actionArgs.args]
                        );
                      })()
                    : undefined;
                  if (
                    $steps["invokeGlobalAction"] != null &&
                    typeof $steps["invokeGlobalAction"] === "object" &&
                    typeof $steps["invokeGlobalAction"].then === "function"
                  ) {
                    $steps["invokeGlobalAction"] =
                      await $steps["invokeGlobalAction"];
                  }
                }}
                priceMin={(() => {
                  try {
                    return null == currentItem.price_max
                      ? Number(currentItem.price_min).toLocaleString("en-US")
                      : currentItem.price_max == null ||
                          currentItem.price_max === ""
                        ? Number(currentItem.price_min).toLocaleString("en-US")
                        : Number(currentItem.price_min).toLocaleString(
                            "en-US"
                          ) +
                          " تا " +
                          Number(currentItem.price_max).toLocaleString("en-US");
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
                tiile={(() => {
                  try {
                    return currentItem.service;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
              />
            );
          })}
        </ScrollContainerComponent>
      ) : null}
      {isInactive && isOwnDoctor ? (
        // ویجت برای بیماران خاموش است: فقط به خود پزشک، کارت فعال‌سازی با پرداخت همین‌جا روی پروفایل.
        // در حالت isInactiveView (ویجتی روی پروفایل نیست) خودش خدمات را می‌گیرد، چون `/servises`
        // برای پزشکی که هرگز نخریده و center_id ندارد خالی برمی‌گردد.
        <KhedmatActivation
          profileData={$props.profileData}
          centerId={$props.widgetData?.center_id}
          services={$props.isInactiveView ? undefined : $state.apiRequest.data}
        />
      ) : null}

      <Paziresh24Modal
        noTrigger={true}
        noSpacing={
          hasVariant(globalVariants, "screen", "mobileOnly") ? true : undefined
        }
        open={consultationModalOpen}
        onOpenChange={(val: boolean) => setConsultationModalOpen(val)}
        title={
          <div className="flex flex-col gap-1 text-right py-1">
            <span className="text-base font-bold text-slate-800">
              {selectedConsultationItem?.service || "راهنمای خدمت"}
            </span>
          </div>
        }
        body={
          <div className="flex flex-col gap-4 text-right px-4 pb-4 pt-2 text-slate-700 w-full">
            <div className="bg-slate-50 border border-slate-200/90 rounded-2xl p-4 text-sm leading-7 text-slate-800 max-h-72 overflow-y-auto shadow-inner whitespace-pre-line">
              {selectedConsultationItem?.description &&
              selectedConsultationItem.description.trim() !== "" ? (
                selectedConsultationItem.description
              ) : (
                <p className="text-slate-500 text-sm">
                  توضیحات تکمیلی برای این خدمت ثبت نشده است. در صورت نیاز به راهنمایی بیشتر می‌توانید با پزشک گفتگو کنید یا نوبت خود را دریافت نمایید.
                </p>
              )}
            </div>

            <div className="flex items-start gap-2 bg-blue-50/80 border border-blue-100 rounded-xl p-3 text-xs text-blue-900 leading-5">
              <span className="text-base leading-none">💡</span>
              <span>
                چنانچه پس از مطالعه توضیحات سوالی دارید، می‌توانید از طریق دکمه «پرسیدن سوال از دکتر» با پزشک گفتگو کنید یا جهت ثبت نوبت حضوری اقدام فرمایید.
              </span>
            </div>

            <div className="flex flex-col sm:flex-row gap-2.5 pt-2 w-full">
              <button
                type="button"
                className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-bold text-white bg-primary hover:bg-primary/90 active:scale-[0.98] transition-all shadow-sm focus:outline-none cursor-pointer"
                onClick={async () => {
                  try {
                    await $globalActions["Fragment.apiRequest"]?.apply(null, [
                      "POST",
                      "https://apigw.paziresh24.com/v1/hamdast/widget-data/khedmat/log-webhook",
                      undefined,
                      {
                        event_group: "khedmat_consultation_modal_chat",
                        doctor_user_id: $props.profileData?.user_id,
                        doctor_slug: $props.profileData?.seo?.slug,
                        user_id: $ctx.auth?.info?.id,
                        service: selectedConsultationItem?.service,
                        sevice: selectedConsultationItem?.service,
                        id: selectedConsultationItem?.id,
                        terminal_id: getCookie("terminal_id")
                      }
                    ]);
                  } catch (e) {
                    console.error("Failed to log consultation chat click:", e);
                  }
                  if (selectedConsultationItem?.chat_url) {
                    window.location.assign(selectedConsultationItem.chat_url);
                  }
                }}
              >
                <svg
                  className="w-4 h-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                  />
                </svg>
                <span>پرسیدن سوال از دکتر</span>
              </button>

              <button
                type="button"
                className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-bold text-slate-700 bg-slate-100 hover:bg-slate-200/90 active:scale-[0.98] border border-slate-300/80 transition-all focus:outline-none cursor-pointer"
                onClick={async () => {
                  try {
                    await $globalActions["Fragment.apiRequest"]?.apply(null, [
                      "POST",
                      "https://apigw.paziresh24.com/v1/hamdast/widget-data/khedmat/log-webhook",
                      undefined,
                      {
                        event_group: "khedmat_consultation_modal_booking",
                        doctor_user_id: $props.profileData?.user_id,
                        doctor_slug: $props.profileData?.seo?.slug,
                        user_id: $ctx.auth?.info?.id,
                        service: selectedConsultationItem?.service,
                        sevice: selectedConsultationItem?.service,
                        id: selectedConsultationItem?.id,
                        terminal_id: getCookie("terminal_id")
                      }
                    ]);
                  } catch (e) {
                    console.error("Failed to log consultation booking click:", e);
                  }
                  const bookingUrl = `https://www.paziresh24.com/booking/${$props.profileData?.seo?.slug}/?centerId=${$props.widgetData?.center_id}`;
                  __nextRouter?.push(bookingUrl);
                }}
              >
                <svg
                  className="w-4 h-4 text-slate-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
                <span>دریافت نوبت</span>
              </button>
            </div>
          </div>
        }
      />

      <ApiRequest
        data-plasmic-name={"apiRequest"}
        data-plasmic-override={overrides.apiRequest}
        className={classNames("__wab_instance", sty.apiRequest)}
        errorDisplay={null}
        loadingDisplay={
          (() => {
            try {
              return (
                $props.widgetData?.center_id ==
                "6ac517d3-c583-4225-ae97-39d7bda66b58"
              );
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return true;
              }
              throw e;
            }
          })() ? (
            <Icon2Icon
              className={classNames("all", sty.svg__c5OeM)}
              role={"img"}
            />
          ) : null
        }
        method={"GET"}
        onError={async (...eventArgs: any) => {
          generateStateOnChangeProp($state, ["apiRequest", "error"]).apply(
            null,
            eventArgs
          );
        }}
        onLoading={async (...eventArgs: any) => {
          generateStateOnChangeProp($state, ["apiRequest", "loading"]).apply(
            null,
            eventArgs
          );
        }}
        onSuccess={async (...eventArgs: any) => {
          generateStateOnChangeProp($state, ["apiRequest", "data"]).apply(
            null,
            eventArgs
          );
        }}
        ref={ref => {
          $refs["apiRequest"] = ref;
        }}
        url={(() => {
          try {
            return `https://apigw.paziresh24.com/v1/hamdast/widget-data/khedmat/servises?center_id=${$props.widgetData?.center_id}&user_id=${$props.profileData.user_id}`;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "card", "paziresh24Button", "modal", "apiRequest"],
  card: ["card"],
  paziresh24Button: ["paziresh24Button"],
  modal: ["modal"],
  apiRequest: ["apiRequest"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  card: typeof Card;
  paziresh24Button: typeof Paziresh24Button;
  modal: typeof Paziresh24Modal;
  apiRequest: typeof ApiRequest;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHamdastKhedmatWidget__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHamdastKhedmatWidget__VariantsArgs;
    args?: PlasmicHamdastKhedmatWidget__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHamdastKhedmatWidget__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHamdastKhedmatWidget__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHamdastKhedmatWidget__ArgProps,
          internalVariantPropNames: PlasmicHamdastKhedmatWidget__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHamdastKhedmatWidget__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHamdastKhedmatWidget";
  } else {
    func.displayName = `PlasmicHamdastKhedmatWidget.${nodeName}`;
  }
  return func;
}

export const PlasmicHamdastKhedmatWidget = Object.assign(
  // Top-level PlasmicHamdastKhedmatWidget renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    card: makeNodeComponent("card"),
    paziresh24Button: makeNodeComponent("paziresh24Button"),
    modal: makeNodeComponent("modal"),
    apiRequest: makeNodeComponent("apiRequest"),

    // Metadata about props expected for PlasmicHamdastKhedmatWidget
    internalVariantProps: PlasmicHamdastKhedmatWidget__VariantProps,
    internalArgProps: PlasmicHamdastKhedmatWidget__ArgProps
  }
);

export default PlasmicHamdastKhedmatWidget;
/* prettier-ignore-end */
